/**
 * DriftPanel — tools whose backend endpoint moved or disappeared.
 * Extracted verbatim from AiUsageDashboard.tsx:919-954.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import type { ToolCatalogDrift } from '../../../services/aiControlApi';

interface Props {
  drift: ToolCatalogDrift[];
  onEdit: (toolId: string) => void;
}

const DriftPanel: React.FC<Props> = ({ drift, onEdit }) => (
  <div className="bg-amber-50 border border-amber-200 rounded-xl overflow-hidden">
    <div className="px-4 py-3 border-b border-amber-200/60 flex items-center gap-2">
      <AlertTriangle size={14} className="text-amber-600" />
      <div>
        <h2 className="text-sm font-semibold text-gray-900">Drift Alerts</h2>
        <p className="text-[11px] text-gray-600">
          {drift.length} tool{drift.length === 1 ? '' : 's'} reference endpoints that no longer exist in the repo.
          Fix or disable before the agent returns stale data.
        </p>
      </div>
    </div>
    <ul className="divide-y divide-amber-200/40">
      {drift.map((d) => (
        <li key={d.toolId} className="px-4 py-2 flex items-center justify-between gap-3 text-xs">
          <div className="min-w-0">
            <span className="font-mono text-gray-800">{d.toolId}</span>
            <span className="ml-2 text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-amber-100 text-amber-700">
              {d.kind === 'endpoint_removed' ? 'Endpoint removed' : 'Path drift'}
            </span>
            <p className="text-[11px] text-gray-600 mt-0.5 truncate">{d.detail}</p>
          </div>
          <button
            type="button"
            onClick={() => onEdit(d.toolId)}
            className="min-h-[44px] px-2 text-[11px] text-amber-700 hover:underline font-medium whitespace-nowrap"
          >
            Edit tool
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export default DriftPanel;
